import { useTheme } from '@emotion/react';
import { Image } from '../picture/picture';
import { Link } from '../styled/Link';
import { PromoCardTypes } from '../../models/promo-card';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';

export function PromoCard({ item }: { item: PromoCardTypes }) {
  const theme = useTheme();
  return (
    <Link
      css={{
        marginBottom: 16,
        borderRadius: 4,
        transition: 'all 0.3s ease',
        ':hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.1)',
        },
        ...theme.mixins.col(3),
        [DEVICE_SCREENS_MAX_STRING.md]: {
          ...theme.mixins.col(2),
        },
        [DEVICE_SCREENS_MAX_STRING.sm]: {
          flex: `0 0 100%`,
          minHeight: 256,
          marginRight: 8,
          marginLeft: 8,
          minWidth: 'calc(100% - 16px)',
          maxWidth: 'calc(100% - 16px)',
        },
        position: 'relative',
        width: '100%',
        minHeight: 430,
        paddingRight: 8,
        paddingLeft: 8,
      }}
      isBlank={item.is_blank}
      href={item.url}
    >
      <div
        css={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          overflow: 'hidden',
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0, 0.2)',
          zIndex: 1,
          borderRadius: 4,
        }}
      />
      <div
        css={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          overflow: 'hidden',
          width: '100%',
          height: '100%',
          zIndex: 0,
          borderRadius: 4,
        }}
      >
        <Image
          image={item}
          alt={item.title}
          css={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
      <div
        css={{
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          width: '100%',
          height: '100%',
          zIndex: 3,
          padding: 16,
        }}
      >
        <h3
          css={{
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: 24,
            color: theme.colors.white,
            [DEVICE_SCREENS_MAX_STRING.sm]: {
              fontSize: 18,
            },
          }}
        >
          {item.title}
        </h3>
        <p
          css={{
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: 18,
            color: theme.colors.white,
            [DEVICE_SCREENS_MAX_STRING.sm]: {
              fontSize: 14,
            },
          }}
        >
          {item.short_title}
        </p>
      </div>
      {item.show_button && (
        <div
          css={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            overflow: 'hidden',
            width: '100%',
            zIndex: 3,
            [DEVICE_SCREENS_MAX_STRING.sm]: {
              justifyContent: 'flex-end',
            },
          }}
        >
          <div
            css={{
              fontFamily: 'Montserrat',
              fontWeight: 600,
              fontSize: 15,
              color: theme.colors.white,
              margin: 16,
              background: theme.colors.primary,
              padding: '8px 16px',
              borderRadius: 32,
              width: 138,
              textAlign: 'center',
            }}
          >
            {item.text_button ? item.text_button : 'Подробнее'}
          </div>
        </div>
      )}
    </Link>
  );
}
